import React from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import { ExternalLink } from 'react-external-link'
import { useQueryParamLang, useLanguage, useMe } from '../../../hooks'
import { setSize } from '../../../style'
import Text from '../../../components/common/Text'
import Block from '../../../components/common/Block'
import Row from '../../../components/common/Row'
import Spacer from '../../../components/common/Spacer'
import ImageBackground from '../../../components/common/ImageBackground'
import SplitFlapDisplay from '../../../components/common/SplitFlapDisplay'

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #ffffff;
`

const VitaminWellBanner = () => {

    const { puid, offset = 0 } = useParams()
    const { lang } = useQueryParamLang()
    const { t } = useLanguage(lang)

    const [loadingInfo, error, medalInfo] = useMe({ puid })

    if (loadingInfo) {
        return (
            // TODO: add a nice loading component to be reused across widgets
            <Block alignItems="center">
                <Text>{t('loadingComp.title')}</Text>
            </Block>
        )
    }

    if (error || medalInfo == null) {
        return null
    }

    const {
        treesPlantedTribe,
        invitationLink,
    } = medalInfo || {}

    return (
        <MainContainer>

            <Row bgColor="blueLight" justifyContent="center" alignItems="center">
                <ImageBackground
                    height="100px"
                    width="400px"
                    imageName="treesTrio@2x.png"
                    style={{
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                    }}
                />

                <Spacer row />

                <Block style={{ minWidth: '300px' }} ph="XXS" pv="XXXL">
                    <SplitFlapDisplay
                        number={treesPlantedTribe + parseInt(offset, 10)}
                        length={6}
                        size={setSize('S', 'XS')}
                        alignSelf="center"
                    />
                    <Spacer size="XL" />
                    <Text center medium size="M">{t('vitaminWellBanner.openTitle.title')}</Text>
                </Block>

                <Spacer row />

                <ImageBackground
                    height="100px"
                    width="400px"
                    imageName="treesTrio@2x.png"
                    style={{
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                    }}
                />
            </Row>

            <Block bgColor="blueLight3" justifyContent="center" alignItems="center" pv="XXXXL">
                <Text uppercase bold center size="L">
                    {t('vitaminWellBanner.keepPlanting.title')}
                </Text>
                <Spacer size="XXXL" />
                <ImageBackground
                    height="45px"
                    width="132px"
                    imageName="logoFull@2x.png"
                />
                <Spacer />
                <Text medium center size="S" style={{ maxWidth: '60%' }}>
                    {t('vitaminWellBanner.downloadApp.title')}
                    <strong> Vitamin Well Green Virtual Run</strong>
                </Text>
                <Spacer size="XXL" />
                <Row justifyContent="center" alignItems="center">
                    <ExternalLink href={invitationLink}>
                        <ImageBackground
                            height="48px"
                            width="140px"
                            imageName="buttonGooglePlay@2x.png"
                        />
                    </ExternalLink>
                    <Spacer row />
                    <ExternalLink href={invitationLink}>
                        <ImageBackground
                            height="48px"
                            width="140px"
                            imageName="buttonAppStore@2x.png"
                        />
                    </ExternalLink>
                </Row>
            </Block>
        </MainContainer>
    )
}

export default VitaminWellBanner
